import AuthAxios from 'utils/authAxios';

import { useQuery, useMutation } from 'react-query';
import { dataApiUrl } from 'utils/url';

const DATA_API_URL = dataApiUrl();
const ADMIN_MEMBERSHIP_PERKS_URL = `${DATA_API_URL}/admin/membership-perks`;

export function useGetMembershipPerks(params) {
  return useQuery(
    ['getMembershipPerks', params.page_index, params.page_size],
    () => AuthAxios.get(`${ADMIN_MEMBERSHIP_PERKS_URL}`, { params: { ...params } }),
    {
      select: res => res?.data?.data,
    }
  );
}

export function useGetMembershipPerk(id) {
  return useQuery(['getMembershipPerk', id], () => AuthAxios.get(`${ADMIN_MEMBERSHIP_PERKS_URL}/${id}`), {
    select: res => res?.data?.data,
  });
}

export function useCreateMembershipPerk(options) {
  return useMutation(body => AuthAxios.post(`${ADMIN_MEMBERSHIP_PERKS_URL}`, body), options);
}

export function useUpdateMembershipPerk(options) {
  return useMutation(_body => {
    const { id, ...body } = _body;
    return AuthAxios.patch(`${ADMIN_MEMBERSHIP_PERKS_URL}/${id}`, body);
  }, options);
}

export function useDeleteMembershipPerk(options) {
  return useMutation(id => AuthAxios.delete(`${ADMIN_MEMBERSHIP_PERKS_URL}/${id}`), options);
}

export function useGetSignedUrl({ filename, ext, options }) {
  return useQuery(
    ['signedURL', filename, ext],
    () => {
      return AuthAxios.get(`${ADMIN_MEMBERSHIP_PERKS_URL}/signedUrl`, { params: { ext } });
    },
    {
      enabled: !!ext && !!filename,
      select: res => res?.data?.data,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      ...options,
    }
  );
}
